const files = require.context('.', !1, /\.js$/)
import plugins from '../common/index.js'

files.keys().forEach((key) => {
  if (key === './index.js') return
  plugins[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

export default plugins
